import { BaseEntity, getCachedSolarSystemEntity } from ".";
import { IGet_universe_planets_planet_id_ok } from "../service/esiclient";

export class PlanetEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Planet";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    //const id = this._id;
    const props: Partial<IGet_universe_planets_planet_id_ok> = this.props;

    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      // - Data Type
      entity.properties["data_type"] = {
        type: Excel.CellValueType.string,
        basicValue: "Planet",
      };
      // - Id
      entity.text = "Planet";
      // - Name
      if (props.name) entity.text = props.name;
      if (props.system_id) {
        const solarSystemEntity = await getCachedSolarSystemEntity(props.system_id);
        if (solarSystemEntity !== null) {
          entity.properties["solar_system"] = await solarSystemEntity.toJson();
        }
      }
    }
    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
      compact: {
        icon: "Atom",
      },
    };

    return entity;
  }
}
